function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import renderTemplateImpl from '../renderTemplate';
import NativeAdTrackerImpl from '../NativeAdTracker';
import { carouselTemplate as carouselTemplateImpl } from './carouselTemplate';
import { track } from '../../../tracking';
import { withAdClickedEvent } from '../../../tracking/events';
var transformDirection = {
  PREV: -1,
  NEXT: 1
};

var CarouselAdComponent = /*#__PURE__*/function () {
  function CarouselAdComponent(adType, shouldTrackEvent) {
    var renderTemplate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : renderTemplateImpl;
    var carouselTemplate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : carouselTemplateImpl;
    var NativeAdTracker = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : NativeAdTrackerImpl;
    var fetch = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : window.fetch.bind(window);
    var delaySlideClickTime = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1000;

    _classCallCheck(this, CarouselAdComponent);

    this.adtype = adType;
    this.renderTemplate = renderTemplate;
    this.NativeAdTracker = NativeAdTracker;
    this.fetch = fetch;
    this.shouldTrackEvent = shouldTrackEvent;
    this.carouselTemplate = carouselTemplate;
    this.offset = 0;
    this.pageIndex = 0;
    this.delaySlideClickTime = delaySlideClickTime;
    this.isLeadAd = adType === 'carousel-lead';
  }

  _createClass(CarouselAdComponent, [{
    key: "processJson",
    value: function processJson(json) {
      var pages = json.pages.map(function (page) {
        var actionTypeKey = "actionType".concat(page.actiontype.substring(0, 1).toUpperCase()).concat(page.actiontype.substring(1));
        return _objectSpread(_objectSpread({}, page), {}, _defineProperty({}, actionTypeKey, true));
      });
      return _objectSpread(_objectSpread({}, json), {}, {
        pages: pages
      });
    }
  }, {
    key: "getCarouselPages",
    value: function getCarouselPages(json) {
      return json.pages.map(function (page) {
        return _objectSpread(_objectSpread({}, page), {}, {
          viewed: false
        });
      });
    }
  }, {
    key: "addAdClickEventListeners",
    value: function addAdClickEventListeners(renderTarget, adSpot, processedJson) {
      var _this = this;

      var brandClickElement = renderTarget.getElementsByClassName('native-carousel__brand')[0];
      var imageQuerySelector = this.isLeadAd ? '.native-carousel__image' : '.native-carousel__image a';
      var imageClickElements = renderTarget.querySelectorAll(imageQuerySelector);
      var textClickElements = renderTarget.getElementsByClassName('native-carousel__text');
      var ctaElementsQuerySelector = this.isLeadAd ? '.native-carousel__action-button' : '.native-carousel__action-link';
      var ctaElements = renderTarget.querySelectorAll(ctaElementsQuerySelector);
      var clickElements = [brandClickElement].concat(_toConsumableArray(imageClickElements), _toConsumableArray(textClickElements), _toConsumableArray(ctaElements));
      clickElements.forEach(function (element) {
        return element && element.addEventListener('click', function () {
          if (_this.isLeadAd) {
            adSpot.leadClickCallback(_this.toLeadAdJson(processedJson));
          }

          track(withAdClickedEvent(), adSpot, _this.shouldTrackEvent);
        });
      });
    }
  }, {
    key: "addTermsClickEventListeners",
    value: function addTermsClickEventListeners(renderTarget) {
      var termsOpenButtons = _toConsumableArray(renderTarget.getElementsByClassName('native-carousel__terms-open-button'));

      if (termsOpenButtons.length === 0) {
        return;
      }

      var termsCloseButtons = _toConsumableArray(renderTarget.getElementsByClassName('native-carousel__terms-close-button'));

      if (termsCloseButtons.length === 0) {
        return;
      }

      var overlay = renderTarget.getElementsByClassName('native-carousel__card-overlay')[0];

      if (!overlay) {
        return;
      }

      termsOpenButtons.forEach(function (button) {
        return button.addEventListener('click', function () {
          return overlay.classList.add('show');
        });
      });
      termsCloseButtons.forEach(function (button) {
        return button.addEventListener('click', function () {
          return overlay.classList.remove('show');
        });
      });
    }
  }, {
    key: "render",
    value: function render(json, renderTarget, adSpot) {
      var _this2 = this;

      this.offset = 0;
      this.pageIndex = 0;
      var processedJson = this.processJson(json);
      processedJson.isLeadAd = this.isLeadAd;
      return this.renderTemplate(renderTarget, processedJson, this.carouselTemplate).then(function () {
        _this2.loadCarousel(renderTarget, processedJson);

        _this2.addAdClickEventListeners(renderTarget, adSpot, processedJson);

        _this2.addTermsClickEventListeners(renderTarget);
      });
    }
  }, {
    key: "loadCarousel",
    value: function loadCarousel(element, json) {
      var carouselPages = this.getCarouselPages(json);
      this.displayCarousel(element, carouselPages);
      this.trackFirstCarouselPageView(carouselPages);
      this.trackThirdParty(json.trackers);
      this.addLogoClickTracking(element, json.trackers);
    }
  }, {
    key: "addLogoClickTracking",
    value: function addLogoClickTracking(element, trackers) {
      var _this3 = this;

      var logo = element.getElementsByClassName('native-carousel__brand')[0];

      if (logo) {
        logo.addEventListener('click', function () {
          _this3.NativeAdTracker.trackLogoClick(trackers);
        });
      }
    }
  }, {
    key: "trackThirdParty",
    value: function trackThirdParty(trackers) {
      this.NativeAdTracker.trackDownloadImpression(trackers);
    }
  }, {
    key: "displayCarousel",
    value: function displayCarousel(element, carouselPages) {
      var slides = element.getElementsByClassName('native-carousel__slide');
      var wrapper = element.getElementsByClassName('native-carousel__slide-wrapper')[0];
      var nextArrow = element.getElementsByClassName('native-carousel__arrow-next')[0];
      var prevArrow = element.getElementsByClassName('native-carousel__arrow-prev')[0];
      var nextArrowPlaceholder = element.getElementsByClassName('native-carousel__arrow-next-placeholder')[0];
      var prevArrowPlaceholder = element.getElementsByClassName('native-carousel__arrow-prev-placeholder')[0];
      if (slides.length === 0) return;
      var slideWidthMarginPx = this.getSlideWidthMargin(slides);
      var slideWidthPx = slides[0].offsetWidth;
      var slideWidthWithMargin = this.getSlideWidthPercent(slideWidthPx + slideWidthMarginPx, wrapper);
      var slideWidthWithoutMargin = this.getSlideWidthPercent(slideWidthPx, wrapper);
      var nextPageSnipetWidth = 100 - slideWidthWithoutMargin;
      var slideWidthMinusNextSlideWidth = slideWidthWithoutMargin - nextPageSnipetWidth;
      this.addNextArrowClickEventListener(element, slides, wrapper, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, carouselPages, slideWidthWithMargin, slideWidthMinusNextSlideWidth);
      this.addPrevArrowClickEventListener(element, slides, wrapper, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, carouselPages, slideWidthWithMargin, slideWidthMinusNextSlideWidth);
    }
  }, {
    key: "getSlideWidthMargin",
    value: function getSlideWidthMargin(slides) {
      var computedStyle = getComputedStyle(slides[0]);
      return parseInt(computedStyle.marginRight);
    }
  }, {
    key: "getSlideWidthPercent",
    value: function getSlideWidthPercent(slideWidthPx, wrapper) {
      var slideParentWidthPx = wrapper.offsetWidth;
      return Math.round(slideWidthPx / slideParentWidthPx * 100);
    }
  }, {
    key: "addNextArrowClickEventListener",
    value: function addNextArrowClickEventListener(element, slides, wrapper, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, carouselPages, slideWidth, slideWidthMinusNextSlideWidth) {
      var _this4 = this;

      nextArrow.addEventListener('click', function () {
        _this4.offset -= _this4.isSecondLastPage(slides) ? slideWidthMinusNextSlideWidth : slideWidth;

        _this4.switchPage(element, wrapper, slides, carouselPages, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, transformDirection.NEXT);
      });
    }
  }, {
    key: "addPrevArrowClickEventListener",
    value: function addPrevArrowClickEventListener(element, slides, wrapper, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, carouselPages, slideWidth, slideWidthMinusNextSlideWidth) {
      var _this5 = this;

      prevArrow.addEventListener('click', function () {
        _this5.offset += _this5.isLastPage(slides) ? slideWidthMinusNextSlideWidth : slideWidth;

        _this5.switchPage(element, wrapper, slides, carouselPages, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, transformDirection.PREV);
      });
    }
  }, {
    key: "switchPage",
    value: function switchPage(element, wrapper, slides, carouselPages, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder, pageChange) {
      wrapper.style.transform = "translateX(".concat(this.offset, "%)");
      this.pageIndex += pageChange;
      this.switchCardContent(element);
      this.showOrHideArrows(slides, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder);
      var carouselPage = carouselPages[this.pageIndex];
      this.trackCarouselPageView(carouselPage);
    }
  }, {
    key: "switchCardContent",
    value: function switchCardContent(element) {
      var _this6 = this;

      var isUpliftTemplate = element.getElementsByClassName('native-carousel-ad-uplift').length > 0;

      if (!isUpliftTemplate) {
        return;
      }

      var cardContents = element.getElementsByClassName('native-carousel__card-content');

      _toConsumableArray(cardContents).forEach(function (cardContent, i) {
        cardContent.style.display = i === _this6.pageIndex ? 'flex' : 'none';
      });
    }
  }, {
    key: "showOrHideArrows",
    value: function showOrHideArrows(slides, nextArrow, nextArrowPlaceholder, prevArrow, prevArrowPlaceholder) {
      var _this7 = this;

      if (this.isFirstPage()) {
        prevArrow.style.display = 'none';
        this.enableSlideClickAfterDelay(prevArrowPlaceholder, function () {
          return _this7.isFirstPage();
        });
      } else {
        prevArrow.style.display = 'block';
      }

      if (this.isLastPage(slides)) {
        nextArrow.style.display = 'none';
        this.enableSlideClickAfterDelay(nextArrowPlaceholder, function () {
          return _this7.isLastPage(slides);
        });
      } else {
        nextArrow.style.display = 'block';
      }
    }
  }, {
    key: "enableSlideClickAfterDelay",
    value: function enableSlideClickAfterDelay(arrowPlaceholder, shouldHidePlaceholder) {
      arrowPlaceholder.style.display = 'block';
      setTimeout(function () {
        if (shouldHidePlaceholder()) {
          arrowPlaceholder.style.display = 'none';
        }
      }, this.delaySlideClickTime);
    }
  }, {
    key: "isFirstPage",
    value: function isFirstPage() {
      return this.pageIndex === 0;
    }
  }, {
    key: "isSecondLastPage",
    value: function isSecondLastPage(slides) {
      return this.pageIndex === slides.length - 2;
    }
  }, {
    key: "isLastPage",
    value: function isLastPage(slides) {
      return this.pageIndex === slides.length - 1;
    }
  }, {
    key: "trackFirstCarouselPageView",
    value: function trackFirstCarouselPageView(carouselPages) {
      if (carouselPages.length > 0) {
        this.trackCarouselPageView(carouselPages[0]);
      }
    }
  }, {
    key: "trackCarouselPageView",
    value: function trackCarouselPageView(carouselPage) {
      if (carouselPage.viewedbeacon && !carouselPage.viewed) {
        this.fetch(carouselPage.viewedbeacon, {
          credentials: 'include'
        });
        carouselPage.viewed = true;
      }
    }
  }, {
    key: "toLeadAdJson",
    value: function toLeadAdJson(processedJson) {
      var currentPage = processedJson.pages[this.pageIndex];
      var brandlogourl = processedJson.brandlogourl,
          projecttitle = processedJson.projecttitle,
          addescription = processedJson.addescription,
          actionurl = processedJson.actionurl,
          impressionurl = processedJson.impressionurl,
          leadcompleteurl = processedJson.leadcompleteurl,
          enquirysubmissionurl = processedJson.enquirysubmissionurl,
          lmscampaignid = processedJson.lmscampaignid;
      return {
        adtype: this.adtype,
        admessagetext: currentPage.admessagetext,
        heroimageurl: currentPage.heroimageurl,
        brandlogourl: brandlogourl,
        projecttitle: projecttitle,
        addescription: addescription,
        actionurl: actionurl,
        impressionurl: impressionurl,
        leadcompleteurl: leadcompleteurl,
        enquirysubmissionurl: enquirysubmissionurl,
        lmscampaignid: lmscampaignid
      };
    }
  }]);

  return CarouselAdComponent;
}();

export default CarouselAdComponent;
//# sourceMappingURL=CarouselAdComponent.js.map